import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/jobs/$id/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/admin/jobs/$id/details',
      params: { id: params.id },
      replace: true,
    });
  },
});
